import { okposItemUpdate, shopItemUpdate } from "../lib/ec2-api-lib";
import { posList } from "./posList";

export function updateItem({ shopInfo, id, body }) {
  if (!posList.includes(shopInfo.posName)) return { err: { message: "INVALID POSNAME" } };
  const params = { shopId: shopInfo.shopId, id, body };
  if (shopInfo.posName === "OKPOS") return okposItemUpdate(params);
  else return shopItemUpdate(params);
}